/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable unicorn/no-nested-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable import/order */
import {
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { styles } from './style';
import { useTranslation } from 'react-i18next';
import { ManageBaseTableRow } from './manage-base-row';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';
import { useGetSubsidiaryListQuery } from '@bvi/admin-panel/entities/subsidiary/api-slice';
import { selectSubsidiary } from '@bvi/admin-panel/entities/subsidiary/selectors';
import { useGetOrganizationListQuery } from '@bvi/admin-panel/entities/organization/api-slice';
import { selectOrganization } from '@bvi/admin-panel/entities/organization/selectors';
import { useGetPerpetratorListQuery } from '@bvi/admin-panel/entities/perpetrator/api-slice';
import { selectPerpetrator } from '@bvi/admin-panel/entities/perpetrator/selectors';
import { useGetDefenseListQuery } from '@bvi/admin-panel/entities/defense/api-slice';
import { selectDefense } from '@bvi/admin-panel/entities/defense/selectors';
import { useGetExceptionListQuery } from '@bvi/admin-panel/entities/exception/api-slice';
import { selectException } from '@bvi/admin-panel/entities/exception/selectors';
import { useGetOrganizationTypeListQuery } from '@bvi/admin-panel/entities/organization-type/api-slice';
import { selectOrganizationType } from '@bvi/admin-panel/entities/organization-type/selectors';
import { useGetJobPositionListQuery } from '@bvi/admin-panel/entities/job-position/api-slice';
import { selectJobPosition } from '@bvi/admin-panel/entities/job-position/selectors';
import { useGetOrderListQuery } from '@bvi/admin-panel/entities/order/api-slice';
import { selectOrder } from '@bvi/admin-panel/entities/order/selectors';
import { useGetDamageListQuery } from '@bvi/admin-panel/entities/damage/api-slice';
import { selectDamage } from '@bvi/admin-panel/entities/damage/selectors';
import { useGetCountryListQuery } from '@bvi/admin-panel/entities/country/api-slice';
import { selectCountry } from '@bvi/admin-panel/entities/country/selectors';
import { Span } from '@bvi/common-components';
import { IManageBaseData, IManageBaseListResponse } from '@bvi/api-interfaces/response/manage-base-data';
import {
  selectManageListStatsMap,
  useGetManageListStatsQuery,
} from '@bvi/admin-panel/entities/manage-list-stats/api-slice';

interface IManageBaseTableProperties {
  tabValue: ManageBaseDataKeys;
  query: string;
}

const ManageBaseTableComponent: FC<IManageBaseTableProperties> = ({
  tabValue,
  query,
}) => {
  const { t } = useTranslation();

  const { data: subsidiaryList, isLoading: isSubsidiaryLoading } = useGetSubsidiaryListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.SUBSIDIARIES,
      selectFromResult: ({ data, isLoading }) => ({
        data:
          tabValue === ManageBaseDataKeys.SUBSIDIARIES
            ? selectSubsidiary(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: organizationList, isLoading: isOrganizationLoading } = useGetOrganizationListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.ORGANIZATIONS,
      selectFromResult: ({ data, isLoading }: { data?: IManageBaseListResponse; isLoading: boolean }) => ({
        data:
          tabValue === ManageBaseDataKeys.ORGANIZATIONS
            ? selectOrganization(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: perpetratorList, isLoading: isPerpetratorLoading } = useGetPerpetratorListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.PERPETRATORS,
      selectFromResult: ({ data, isLoading }: { data?: IManageBaseListResponse; isLoading: boolean }) => ({
        data:
          tabValue === ManageBaseDataKeys.PERPETRATORS
            ? selectPerpetrator(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: defenseList, isLoading: isDefenseLoading } = useGetDefenseListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.DEFENSES,
      selectFromResult: ({ data, isLoading }: { data?: IManageBaseListResponse; isLoading: boolean }) => ({
        data:
          tabValue === ManageBaseDataKeys.DEFENSES
            ? selectDefense(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: exceptionList, isLoading: isExceptionLoading } = useGetExceptionListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.EXCEPTIONS,
      selectFromResult: ({ data, isLoading }: { data?: IManageBaseListResponse; isLoading: boolean }) => ({
        data:
          tabValue === ManageBaseDataKeys.EXCEPTIONS
            ? selectException(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: organizationTypeList, isLoading: isOrganizationTypeLoading } = useGetOrganizationTypeListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.ORGANIZATION_TYPES,
      selectFromResult: ({ data, isLoading }) => ({
        data:
          tabValue === ManageBaseDataKeys.ORGANIZATION_TYPES
            ? selectOrganizationType(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: jobPositionList, isLoading: isJobPositionLoading } = useGetJobPositionListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.JOB_POSITIONS,
      selectFromResult: ({ data, isLoading }: { data?: IManageBaseListResponse; isLoading: boolean }) => ({
        data:
          tabValue === ManageBaseDataKeys.JOB_POSITIONS
            ? selectJobPosition(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: orderList, isLoading: isOrderLoading } = useGetOrderListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.ORDERS,
      selectFromResult: ({ data, isLoading }) => ({
        data:
          tabValue === ManageBaseDataKeys.ORDERS
            ? selectOrder(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: damageList, isLoading: isDamageLoading } = useGetDamageListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.DAMAGES,
      selectFromResult: ({ data, isLoading }) => ({
        data:
          tabValue === ManageBaseDataKeys.DAMAGES
            ? selectDamage(data)
            : [],
        isLoading,
      }),
    },
  );

  const { data: countryList, isLoading: isCountryLoading } = useGetCountryListQuery(
    undefined,
    {
      skip: tabValue !== ManageBaseDataKeys.COUNTRIES,
      selectFromResult: ({ data, isLoading }: { data?: IManageBaseListResponse; isLoading: boolean }) => ({
        data:
          tabValue === ManageBaseDataKeys.COUNTRIES
            ? selectCountry(data)
            : [],
        isLoading,
      }),
    },
  );

  const getSourceList = () => {
    switch (tabValue) {
      case ManageBaseDataKeys.SUBSIDIARIES: {
        return subsidiaryList;
      }
      case ManageBaseDataKeys.ORGANIZATIONS: {
        return organizationList;
      }
      case ManageBaseDataKeys.ORGANIZATION_TYPES: {
        return organizationTypeList;
      }
      case ManageBaseDataKeys.PERPETRATORS: {
        return perpetratorList;
      }
      case ManageBaseDataKeys.DEFENSES: {
        return defenseList;
      }
      case ManageBaseDataKeys.EXCEPTIONS: {
        return exceptionList;
      }
      case ManageBaseDataKeys.JOB_POSITIONS: {
        return jobPositionList;
      }
      case ManageBaseDataKeys.ORDERS: {
        return orderList;
      }
      case ManageBaseDataKeys.DAMAGES: {
        return damageList;
      }
      case ManageBaseDataKeys.COUNTRIES: {
        return countryList;
      }
      default: {
        return [];
      }
    }
  };

  const sourceList = getSourceList();

  const { data: statsResponse } = useGetManageListStatsQuery(tabValue);
  const statsById = selectManageListStatsMap(statsResponse);

  const filteredAndSorted = useMemo(() => {
    const list = query
      ? sourceList.filter((s: IManageBaseData) => {
          const lower = query.toLowerCase();
          return (
            String(s.id).includes(lower) ||
            (s.name?.toLowerCase().includes(lower) ?? false)
          );
        })
      : [...sourceList];

    return list.sort((a: IManageBaseData, b: IManageBaseData) => {
      const nameA = a.name?.toLowerCase() ?? '';
      const nameB = b.name?.toLowerCase() ?? '';
      return nameA.localeCompare(nameB);
    });
  }, [query, sourceList]);

  const tableColumns = [
    {
      title: t('manageBaseTable.table.columns.id'),
      width: '8%',
    },
    {
      title: t('manageBaseTable.table.columns.name'),
      width: '38%',
    },
    {
      title: t('manageBaseTable.table.columns.caseCount'),
      width: '14%',
    },
    {
      title: t('manageBaseTable.table.columns.claimantCount'),
      width: '16%',
    },
    {
      title: t('manageBaseTable.table.columns.averageSettlement'),
      width: '16%',
    },
    {
      width: '70px',
    },
  ];

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={styles.fixedTable}>
          <TableHead>
            <TableRow>
              {tableColumns.map((column, index) => (
                <TableCell width={column.width} key={index}>
                  {column.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(
              isSubsidiaryLoading ||
              isOrganizationLoading ||
              isOrganizationTypeLoading ||
              isPerpetratorLoading ||
              isDefenseLoading ||
              isExceptionLoading ||
              isJobPositionLoading ||
              isOrderLoading ||
              isDamageLoading ||
              isCountryLoading
            ) ? (
              <TableRow>
                <TableCell colSpan={tableColumns.length} align="center">
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <CircularProgress size={24} />
                  </Stack>
                </TableCell>
              </TableRow>
            ) : filteredAndSorted.length === 0 ? (
              <TableRow>
                <TableCell colSpan={tableColumns.length} align="center">
                  <Span>{t('manageBaseTable.table.results.empty')}</Span>
                </TableCell>
              </TableRow>
            ) : (
              filteredAndSorted.map(
                (manageBaseList: IManageBaseData) => (
                  <ManageBaseTableRow
                    manageBase={{
                      ...manageBaseList,
                      ...statsById[manageBaseList.id],
                    }}
                    tabValue={tabValue}
                    key={manageBaseList.id}
                  />
                ),
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export const ManageBaseTable = memo(ManageBaseTableComponent);
